import type { BoxSlotTemplateEntity } from "@/modules/boxSlotTemplate/entities/boxSlotTemplateEntity"
import { create } from "@/modules/core/store"

type BoxSlotTemplateStoreActions = {
  addBoxSlotTemplateBeingCreated: (boxSlotTemplate: BoxSlotTemplateEntity[]) => void
  updateBoxSlotTemplateBeingCreated: (boxSlotTemplate: BoxSlotTemplateEntity[]) => void
  clearBoxSlotTemplateBeingCreated: () => void
}

type BoxSlotTemplateStoreState = {
  boxSlotTemplatesBeingCreated: BoxSlotTemplateEntity[]
  actions: BoxSlotTemplateStoreActions
}

const useBoxSlotTemplateStore = create<BoxSlotTemplateStoreState>()((set) => ({
  boxSlotTemplatesBeingCreated: [],
  actions: {
    addBoxSlotTemplateBeingCreated: (boxSlotTemplate: BoxSlotTemplateEntity[]) => {
      set((state) => ({ boxSlotTemplatesBeingCreated: [...state.boxSlotTemplatesBeingCreated, ...boxSlotTemplate] }))
    },
    updateBoxSlotTemplateBeingCreated: (boxSlotTemplate: BoxSlotTemplateEntity[]) => {
      set((state) => {
        const templatesById = new Map(boxSlotTemplate.map((template) => [template.id, template]))
        return {
          boxSlotTemplatesBeingCreated: state.boxSlotTemplatesBeingCreated.map(
            (template) => templatesById.get(template.id) ?? template,
          ),
        }
      })
    },
    clearBoxSlotTemplateBeingCreated: () => {
      set({ boxSlotTemplatesBeingCreated: [] })
    },
  },
}))

export const useBoxSlotTemplatesBeingCreated = () =>
  useBoxSlotTemplateStore((state) => state.boxSlotTemplatesBeingCreated)
export const useBoxSlotTemplateActions = () => useBoxSlotTemplateStore((state) => state.actions)
